import { ReactionType } from '../model/post.types';

export const reactionPickerRows: ReactionType[][] = [
  [
    ReactionType.Fire,
    ReactionType.CheckMark,
    ReactionType.Goat,
    ReactionType.Trophy,
    ReactionType.Rocket,
    ReactionType.Muscle,
  ],
  [
    ReactionType.Heart,
    ReactionType.Tear,
    ReactionType.Relieved,
    ReactionType.HeartEyes,
    ReactionType.Pray,
    ReactionType.Hug,
  ],
  [
    ReactionType.Tada,
    ReactionType.RaisedHands,
    ReactionType.Sparkles,
    ReactionType.Joy,
    ReactionType.OpenMouth,
    ReactionType.ExplodingHead,
  ],
  [
    ReactionType.Cry,
    ReactionType.SweatSmile,
    ReactionType.Skull,
    ReactionType.ThumbsUp,
    ReactionType.Fist,
    ReactionType.Eyes,
  ],
];
